<template>
	<div class='detail-box'>
    <div class="input-box">
			<span>将字段：</span>
			<el-select
				v-model="type"
				size="small">
				<el-option
					label="有效日期"
					value="0">
				</el-option>
				<el-option
					label="专用价格"
					value="1">
				</el-option>
			</el-select>
		</div>
    <div class="input-box" v-show="type === '0'">
			<span>修改为：</span>
			<el-date-picker
				style="width: 300px;"
				:unlink-panels='true'
				:clearable='false'
				size="mini"
				v-model="dateValue"
				type="datetimerange"
				range-separator="至"
				start-placeholder="开始日期"
				end-placeholder="结束日期"
				:default-time="['00:00:00', '23:59:59']"
				format='yyyy-MM-dd HH:mm'
				value-format='yyyy-MM-dd HH:mm:ss'>
			</el-date-picker>
		</div>
		<div class="input-box" v-show="type === '1'">
			<span>修改为：</span>
			<el-radio-group v-model="privatePriceIndex">
				<el-radio :label="0">
					按比例
					<el-input v-model="privatePriceArr[0]" size="mini" style="width:130px;" :disabled="privatePriceIndex !== 0" @input='checkNum(999)'>
						<el-button slot="prepend" icon="el-icon-plus"></el-button>
					</el-input>%
				</el-radio>
				<el-radio :label="1">
					按比例
					<el-input v-model="privatePriceArr[1]" size="mini" style="width:130px;" :disabled="privatePriceIndex !== 1" @input='checkNum(999)'>
						<el-button slot="prepend" icon="el-icon-minus"></el-button>
					</el-input>%
				</el-radio>
				<el-radio :label="2">
					按价格
					<el-input v-model="privatePriceArr[2]" size="mini" style="width:130px;" :disabled="privatePriceIndex !== 2" @input='checkNum(999999.99)'></el-input>元
				</el-radio>
			</el-radio-group>
		</div>
		<div slot="footer" class="dialog-footer">
			<el-button size='small' type='primary' class="fx-big-btn" plain @click="cancel">取消</el-button>
			<el-button size='small' type='primary' class="fx-big-btn" plain v-if="type === '0'" @click="save">保存</el-button>
			<el-button size='small' type='primary' class="fx-big-btn" plain v-if="type === '1'" @click="saveBatchSetPrice">保存</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'editModal',
	props: {
		ids: Array,
		tableData: Array
	},
	data () {
		return {
			type: '0',
			dateValue: [],
			privatePriceIndex: 0,
			privatePriceArr: ['', '', '']
		}
	},
	watch: {
		privatePriceIndex () {
			this.privatePriceArr = ['', '', '']
		},
		type () {
			this.dateValue = []
			this.privatePriceArr = ['', '', '']
			this.privatePriceIndex = 0
		}
	},
	methods: {
		save () {
			if (this.dateValue.length === 0) {
				this.$message.error('请选择有效日期')
				return false
			}
			console.log(this.ids)
			let list = this.ids.map(item => {
				return item.id
			})
			let params = {
				priceIds: list,
				startdate: this.dateValue[0],
				enddate: this.dateValue[1]
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/customer/updatecustomerspecialdate`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('保存成功！')
					this.$emit('cancel', 1)
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		saveBatchSetPrice () {
			let inputIsEmpty = this.privatePriceArr.every((item) => {
				return item === ''
			})
			if (inputIsEmpty) {
				this.$message.success('保存成功！')
				this.$emit('cancel', 1)
				return false
			}
			let list = this.ids.map(item => {
				return item.id
			})
			let logArr = []
			let text = ''
			switch (this.privatePriceIndex) {
			case 0:
				text = '上调'
				break
			case 1:
				text = '下调'
				break
			case 2:
				text = '修改为'
				break
			}
			for (let i = 0; i < list.length; i++) {
				for (let j = 0; j < this.tableData.length; j++) {
					if (list[i] === this.tableData[j].id) {
						logArr.push(`(客户名称)${this.tableData[j].cusName}(SKU 编号)${this.tableData[j].speccode}(SKU名称)${this.tableData[j].pname}(专用价格)${this.tableData[j].speprice} 批量${text}${this.privatePriceArr[this.privatePriceIndex]}${this.privatePriceIndex === 0 || this.privatePriceIndex === 1 ? '%' : ''}`)
						break
					}
				}
			}
			let logtext = logArr.join()
			let changeData = {
				pre: { privatePrice: {} },
				cur: { privatePrice: { text: logtext } }
			}
			const logger = this.$fxLogger.createInfo('custom.custom-else.update', changeData)
			let params = {
				ppIds: list.join(),
				type: this.privatePriceIndex,
				value: +this.privatePriceArr[this.privatePriceIndex]
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/customer/batchUpdateCustomerSpecialPrice`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success('保存成功！')
					this.$emit('cancel', 1)
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		cancel () {
			this.$emit('cancel', 0)
		},
		checkNum (num) {
			this.privatePriceArr[this.privatePriceIndex] = this.privatePriceArr[this.privatePriceIndex].replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			this.privatePriceArr[this.privatePriceIndex] = this.privatePriceArr[this.privatePriceIndex].replace(/^\./g, '')// 验证第一个字符是数字而不是
			this.privatePriceArr[this.privatePriceIndex] = this.privatePriceArr[this.privatePriceIndex].replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			this.privatePriceArr[this.privatePriceIndex] = this.privatePriceArr[this.privatePriceIndex].replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			this.privatePriceArr[this.privatePriceIndex] = this.privatePriceArr[this.privatePriceIndex].replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')// 只能输入一个小数
			this.privatePriceArr[this.privatePriceIndex] = this.privatePriceArr[this.privatePriceIndex] > num ? num : this.privatePriceArr[this.privatePriceIndex]
		}
	}
}
</script>

<style lang="stylus" scoped>
span{
	margin-top :10px
}
.detail-box{
    padding 10px 20px 10px 20px
    display: flex;
    text-align:left ;
	flex-direction: column
    .input-box{
			text-align :left
			width :100%;
			margin-bottom:10px
			.name-input {
				width: 150px;
				margin-right: 10px;
			}
			.select-box{
				width:180px;
				margin-right:10px;
			}
			.el-radio {
				margin-top: 15px
			}
		}
}
.dialog-footer{
    margin-top:20px;
    text-align:center;
	.el-button{
		margin-right :15px
	}
}
.box{
    width:500px;
	height :80px;
	margin-top:-40px
}
.text{
    width:70px;
}
.text1{
    height: 60px;
    line-height:20px;
    overflow-y:auto;
	padding-left:30px
}
.img-list{
	display :inline-block;
    flex-wrap:wrap;
    margin-bottom:10px
}
.img-box{
    margin-top:10px;
    margin-left:25px;
    height: 120px;
    width:120px
}
.radio-box{
	flex-direction: column;
	width:200px;
    margin-top: 10px
	.el-radio{
		margin-left :30px;
		margin-bottom :10px;
		span{
			font-size :12px
		}
	}
}
.rule{
	width :400px;
	margin-left :30px;
	margin-bottom :10px;
}
.reason-input{
	width :300px
}
.logo{
	width:100px;
    position :relative;
    left: 410px;
    top: -110px;
    .logo-img{
        width :100px;
        height :50px
    }
}
.reason-box{
	padding-left :30px;
	display:block;
    height :40px;
    line-height :40px
}
.isRed >>> .el-input__inner{
		color:red
	}
</style>
